import React from "react";

import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { PhoneInput } from "react-international-phone";

import i18n from "../../../i18n";

interface ContactFormPhoneSectionProps {
  control: any;
  errors: any;
}

const ContactFormPhoneSection: React.FC<ContactFormPhoneSectionProps> = ({
  control,
  errors,
}): React.JSX.Element => {
  const { t } = i18n;
  return (
    <Form.Group className="mb-3" controlId="phone">
      <Form.Label>{t("Phone")}</Form.Label>
      <Controller
        control={control}
        name="phone"
        render={({ field: { onChange, onBlur, value } }) => (
          <PhoneInput
            forceDialCode
            defaultCountry="ca"
            inputClassName={`form-control ps-5 ${errors.phone?.message ? "is-invalid" : ""}`}
            onBlur={onBlur}
            onChange={onChange}
            value={value ?? ""}
            countrySelectorStyleProps={{
              buttonClassName: "m-0 p-0",
              buttonStyle: {
                height: "35px",
                position: "absolute",
                border: "none",
                left: "2px",
                top: "2px",
              },
              flagStyle: { height: "16px" },
            }}
            inputProps={{
              name: "phone",
              id: "phone",
              autoComplete: "tel",
            }}
            inputStyle={{
              height: "38px",
              fontSize: "1rem",
              borderRadius: "var(--bs-border-radius)",
            }}
          />
        )}
      />
      <Form.Control.Feedback className="d-block" type="invalid">
        {t(errors.phone?.message)}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default ContactFormPhoneSection;
